var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"bb5bfd2276308b91b9c9dd4dddcc423874d363f9"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["pegasus-web-vehicle@cheweijia"]={id:"bb5bfd2276308b91b9c9dd4dddcc423874d363f9"};
      